var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3567 7.01264C28.6849 5.50027 23.6061 7.60394 21.3719 11.9769L18.686 17.2342C18.3669 17.8588 17.8588 18.3669 17.2342 18.686L11.9769 21.3719C7.60394 23.6061 5.50027 28.6849 7.01264 33.3567L8.83084 38.9734C9.04688 39.6407 9.04688 40.3594 8.83084 41.0267L7.01264 46.6434C5.50027 51.3154 7.60394 56.3941 11.9769 58.6284L17.2342 61.3141C17.8588 61.6334 18.3669 62.1414 18.686 62.7661L21.3719 68.0234C23.6061 72.3964 28.6849 74.5001 33.3567 72.9877L38.9734 71.1694C39.6407 70.9534 40.3594 70.9534 41.0267 71.1694L46.6434 72.9877C51.3154 74.5001 56.3941 72.3964 58.6284 68.0234L61.3141 62.7661C61.6334 62.1414 62.1414 61.6334 62.7661 61.3141L68.0234 58.6284C72.3964 56.3941 74.5001 51.3154 72.9877 46.6434L71.1694 41.0267C70.9534 40.3594 70.9534 39.6407 71.1694 38.9734L72.9877 33.3567C74.5001 28.6849 72.3964 23.6061 68.0234 21.3719L62.7661 18.686C62.1414 18.3669 61.6334 17.8588 61.3141 17.2342L58.6284 11.9769C56.3941 7.60394 51.3154 5.50027 46.6434 7.01264L41.0267 8.83084C40.3594 9.04684 39.6407 9.04688 38.9734 8.83084L33.3567 7.01264ZM22.5326 39.1911L27.2467 34.4767L36.6747 43.9051L55.5311 25.0489L60.2451 29.7629L36.6747 53.3331L22.5326 39.1911Z",
    fill: "#1A8C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessicon);
export default __webpack_public_path__ + "static/media/successicon.0f0c76a2defa27cda698fac71c0661e1.svg";
export { ForwardRef as ReactComponent };